module.exports = __webpack_public_path__ + "static/media/caravanIdR.ffe35cc5.png";